import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: '35rem',
      padding: '1rem',
    },
    closeButton: {
      position: 'absolute',
      top: 24,
      right: 24,
      color: '#000000',
      marginBottom: '1rem',
    },
    title: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: '100%',
      letterSpacing: 0,
      color: '#000000',
      marginBottom: 28,
    },
    paragraph: {
      fontWeight: 400,
      lineHeight: '100%',
      letterSpacing: 0,
      color: '#010303',
      marginBottom: 28,
    },
    link: {
      color: '#0082EB',
      textDecoration: 'underline',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    actions: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 8,
    },
    confirmButton: {
      minWidth: '5.625rem',
      height: '2rem',
      borderRadius: '0.5rem',
      backgroundColor: '#0082EB',
      color: '#FFFFFF',
      fontSize: '1rem',
      fontWeight: 500,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#0073D1',
      },
    },
  }),
);

export default useStyles;
